/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yearly_Plan_Early_BirdInputs */

const en_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annual (Early Bird)`)
};

const ar_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنوي (الحجز المبكر)`)
};

const de_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährlich (Frühbucher)`)
};

const es_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual (anticipado)`)
};

const fr_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuel (Premiers arrivés)`)
};

const it_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuale (Early Bird)`)
};

const ja_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年間（早期割引）`)
};

const ko_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연간(얼리버드)`)
};

const pt_br_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual (Antecipado)`)
};

const ru_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежегодно (ранняя пташка)`)
};

const th_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายปี (ก่อนเวลา)`)
};

const tr_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yıllık (Erken Kayıt)`)
};

const zh_cn_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连续包年（早鸟）`)
};

const zh_tw_yearly_plan_early_bird = /** @type {(inputs: Yearly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年訂閱（早鳥）`)
};

/**
* | output |
* | --- |
* | "Annual (Early Bird)" |
*
* @param {Yearly_Plan_Early_BirdInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const yearly_plan_early_bird = /** @type {((inputs?: Yearly_Plan_Early_BirdInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yearly_Plan_Early_BirdInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yearly_plan_early_bird(inputs)
	if (locale === "ar") return ar_yearly_plan_early_bird(inputs)
	if (locale === "de") return de_yearly_plan_early_bird(inputs)
	if (locale === "es") return es_yearly_plan_early_bird(inputs)
	if (locale === "fr") return fr_yearly_plan_early_bird(inputs)
	if (locale === "it") return it_yearly_plan_early_bird(inputs)
	if (locale === "ja") return ja_yearly_plan_early_bird(inputs)
	if (locale === "ko") return ko_yearly_plan_early_bird(inputs)
	if (locale === "pt_br") return pt_br_yearly_plan_early_bird(inputs)
	if (locale === "ru") return ru_yearly_plan_early_bird(inputs)
	if (locale === "th") return th_yearly_plan_early_bird(inputs)
	if (locale === "tr") return tr_yearly_plan_early_bird(inputs)
	if (locale === "zh_cn") return zh_cn_yearly_plan_early_bird(inputs)
	return zh_tw_yearly_plan_early_bird(inputs)
});